<template>
  <div class="dropdown">
    <button
      class="btn btn-white btn-sm dropdown-toggle"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="true"
    >
      <i class="fa fa-cog"></i>
    </button>
    <ul
      class="dropdown-menu dropdown-menu-right p-xs"
      aria-labelledby="dropdownMenu1"
    >
      <li v-if="Array.isArray(turnosValidos) && turnosValidos.length">
        <label class="control-label">
          {{ $t('turno_por_defecto') }}
        </label>
        <select-cifra
          v-model="turno"
          :options="turnosValidos"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false"
          label="name"
        />
      </li>
      <li>
        <input-checkbox-boolean
          :model-value="ocultarObservaciones"
          tipo="switch"
          @update:model-value="cambiarObservaciones($event, true)"
        >
          {{ $t('ocultar_observaciones') }}
        </input-checkbox-boolean>
      </li>
    </ul>
  </div>
</template>

<script>
import humanEnumName from '../../../../libs/i18n';
import preferencias from '../../../../api/cifra/cuadernos/preferencias';

export default {
  props: {
    // Modelo CuadernoPreferencias
    infoCuaderno: { type: Object, required: true },
  },
  emits: ['recargarCuaderno'],
  data() {
    const prefs = this.infoCuaderno.preferencias || {};
    const turnosValidos = this.infoCuaderno.turnos_validos.map((turnoKey) => (
      {
        name: humanEnumName('alumno_asistencia', 'turno_ausencia', turnoKey),
        value: turnoKey,
      }
    ));
    const turno = prefs.preferencias?.tipo_turno_defecto;
    const ocultarObservaciones = prefs.preferencias?.ocultar_observaciones;

    return {
      turnosValidos,
      preferencias: prefs,
      turno: turnosValidos.find((t) => t.value === turno),
      ocultarObservaciones,
    };
  },
  watch: {
    turno() {
      this.guardarPreferencias();
    },
  },
  mounted() {
    /* global $ */
    // Para que no cierre el dropdown al hacer click en el selector
    $(this.$el).find('.dropdown-menu').on('click', (e) => {
      e.stopPropagation();
    });
  },
  methods: {
    cambiarObservaciones(value) {
      this.ocultarObservaciones = value;
      this.guardarPreferencias();
    },
    guardarPreferencias() {
      preferencias.guardar(
        this.preferencias.cuaderno_profesor_id,
        this.preferencias.tipo_cuaderno,
        {
          tipo_turno_defecto: this.turno?.value,
          ocultar_observaciones: this.ocultarObservaciones,
        },
      ).then(() => {
        this.$emit('recargarCuaderno');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .dropdown-menu {
    min-width: 300px;

    li {
      white-space: nowrap;
    }
  }
</style>
